import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Modal, ModalType, NonPersistedModalName } from '@shared/models/modal.model';
import { TakeUntilDestroy } from '@shared/decorators/take-until-destroy.decorator';
import { EventManager } from '@app/shared/utils/event-manager';
import { LoggerService } from '@app/shared/services/logger.service';
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { UserService } from '@app/shared/services/user.service';
import { User } from '@app/shared/models/user.model';
import { takeUntil } from 'rxjs/operators';
import { RealtimeService } from '@app/shared/services/realtime.service';
import { AppService } from '@app/app.service';
import { Observable } from 'rxjs';
import { UserRepository } from '@app/shared/state/user/user.repository';
import { SharedModule } from '@app/shared/shared.module';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { DividerComponent } from '@app/shared/components/divider/divider.component';
@TakeUntilDestroy
@Component({
  selector: 'slotcom-account-deletion-reactivate',
  templateUrl: './account-deletion-reactivate.component.html',
  styleUrls: ['./account-deletion.component.scss'],
  standalone: true,
  imports: [SharedModule, ButtonComponent, DividerComponent],
})

// eslint-disable-next-line
export class AccountDeletionReactivate implements OnInit {
  logger = inject(LoggerService);
  private eventManager = inject(EventManager);
  private authService = inject(AuthenticationService);
  private userService = inject(UserService);
  private realtimeService = inject(RealtimeService);
  private appService = inject(AppService);
  private userRepo = inject(UserRepository);
  info = inject<Modal>(MAT_DIALOG_DATA);

  remainingDays: number;
  currentUser: User;

  componentDestroy: () => Observable<unknown>;

  ngOnInit() {
    this.currentUser = this.userRepo.getUser();
    const loginDate = new Date().getTime();
    const accountDeletionDate = new Date(this.currentUser.accountDeletionDate).getTime();
    this.remainingDays = this.daysUntilDeletion(loginDate, accountDeletionDate);
  }

  acceptDeletion() {
    this.closeModal();
    this.authService.logout();
  }

  cancelDeletion() {
    this.userService
      .stopAccountDeletion()
      .pipe(takeUntil(this.componentDestroy()))
      .subscribe(() => {
        this.appService.reload();
      });
    this.userService.getUser(this.currentUser.id).subscribe((user: User) => {
      this.userRepo.updateUser(user);
    });
    this.closeModal();
  }

  closeModal() {
    this.eventManager.closeModal(new Modal(NonPersistedModalName.AccountDeletionReactivate, ModalType.View));
  }

  daysUntilDeletion(today: number, deletionDate: number): number {
    const remainingMs = deletionDate - today;
    return Math.floor(remainingMs / (1000 * 3600 * 24));
  }
}
